import { FC, Fragment } from "react";
import { locale } from "src/config/app-config";
import { Wrapper } from "./PaymentMethodsInfo.styled";
import { usePspMollieEnabled } from "src/hooks/usePspMollieEnabled";
import { canHandleApplePay } from "src/utils/applepay/applePayHelper";
import IdealIconBackground from "src/icons/IdealIconBackground";
import BancontactIconBackground from "src/icons/BancontactIconBackground";
import VisaIconBackground from "src/icons/VisaIconBackground";
import MaestroIconBackground from "src/icons/MaestroIconBackground";
import MasterCardIconBackground from "src/icons/MasterCardIconBackground";
import AmexIconBackground from "src/icons/AmexIconBackground";
import GPayIconBackground from "src/icons/GPayIconBackground";
import PaypalIconBackground from "src/icons/PaypalIconBackground";
import Przelewy24IconBackground from "src/icons/Przelewy24IconBackground";
import ApplePayIconBackground from "src/icons/ApplePayIconBackground";
import SofortIconBackground from "src/icons/SofortIconBackground";
import KlarnaIconBackground from "src/icons/KlarnaIconBackground";

const paymentMethodsMap = {
  paypal: <PaypalIconBackground />,
  ideal: <IdealIconBackground />,
  amex: <AmexIconBackground />,
  bancontact: <BancontactIconBackground />,
  visa: <VisaIconBackground />,
  mastercard: <MasterCardIconBackground />,
  maestro: <MaestroIconBackground />,
  klarna: <KlarnaIconBackground />,
  "google-pay": <GPayIconBackground />,
  "apple-pay": <ApplePayIconBackground />,
  "przelewy-24": <Przelewy24IconBackground />,
  sofort: <SofortIconBackground />,
};

type PaymentMethodKeys = keyof typeof paymentMethodsMap;

const paymentMethodsConfig: Record<string, PaymentMethodKeys[]> = {
  en: [
    "visa",
    "maestro",
    "mastercard",
    "amex",
    "apple-pay",
    "google-pay",
    "paypal",
    "klarna",
  ],
  nl: [
    "ideal",
    "bancontact",
    "visa",
    "maestro",
    "mastercard",
    "amex",
    "apple-pay",
    "google-pay",
    "paypal",
    "sofort",
    "klarna",
  ],
  fr: [
    "visa",
    "maestro",
    "mastercard",
    "amex",
    "apple-pay",
    "google-pay",
    "paypal",
    "klarna",
  ],
  de: [
    "visa",
    "maestro",
    "mastercard",
    "amex",
    "apple-pay",
    "google-pay",
    "paypal",
    "sofort",
    "klarna",
  ],
  "en-gb": [
    "visa",
    "maestro",
    "mastercard",
    "amex",
    "apple-pay",
    "google-pay",
    "klarna",
  ],
  "it-it": [
    "visa",
    "maestro",
    "mastercard",
    "amex",
    "apple-pay",
    "google-pay",
    "paypal",
    "klarna",
  ],
  "pl-pl": [
    "visa",
    "maestro",
    "mastercard",
    "amex",
    "apple-pay",
    "google-pay",
    "paypal",
    "przelewy-24",
    "klarna",
  ],
  "es-es": [
    "visa",
    "maestro",
    "mastercard",
    "amex",
    "apple-pay",
    "google-pay",
    "paypal",
    "klarna",
  ],
  "nl-be": [
    "ideal",
    "bancontact",
    "visa",
    "maestro",
    "mastercard",
    "amex",
    "apple-pay",
    "google-pay",
    "paypal",
    "sofort",
    "klarna",
  ],
};

const PaymentMethodsInfo: FC = () => {
  const isMollieEnabled = usePspMollieEnabled();

  return (
    <Wrapper>
      {paymentMethodsConfig[locale].map((method) => {
        if (
          (method === "google-pay" && isMollieEnabled) ||
          (method === "apple-pay" && !canHandleApplePay())
        ) {
          return null;
        }

        return (
          <Fragment key={`checkout-${method}-icon`}>
            {paymentMethodsMap[method]}
          </Fragment>
        );
      })}
    </Wrapper>
  );
};

export default PaymentMethodsInfo;
